var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',_vm._b({ref:"modal",attrs:{"busy":true},scopedSlots:_vm._u([{key:"modal-title",fn:function(){return [_vm._t("title")]},proxy:true},{key:"modal-footer",fn:function(){return [_c('div',{staticClass:"footer"})]},proxy:true}],null,true)},'b-modal',_vm.$attrs,false),[_c('div',{staticClass:"r-clean-modal"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }